import { forwardRef } from 'react';
export const AuthenticatedProviders = forwardRef(
  ({ children, ...props }, ref) => {
    return <>{children}</>;
  }
);
